
import Vue from 'vue';
import { mapState } from 'vuex';
import EnterpriseUpsellBadge from '@/components/EnterpriseUpsellWrapper/EnterpriseUpsellBadge.vue';

export default Vue.extend({
	name: 'EnterpriseUpsellWrapper',
	props: {
		value: { type: Boolean, default: false },
		allowIsAdminOverride: { type: Boolean, default: false },
		containerStyles: { type: Object, default: () => ({}) },
		enterpriseRequiredContainerStyles: { type: Object, default: () => ({}) }, // Only enabled if `value` is true
	},
	computed: {
		...mapState([
			'isAdminProxyingUser',
			'user',
		]),
		showIsAdminOverrideBtns () {
			return !!(this.allowIsAdminOverride && (this.user?.isAdmin || this.isAdminProxyingUser));
		},
	},
	components: {
		EnterpriseUpsellBadge,
	},
});
